'use strict';
import axios from 'axios';
import router from '../../../router';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader
const actions = {
  getNewSchedule(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/scheduleshift/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Shift Master By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftMasterByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftmaster/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Shift Master By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftMasterByCompanyV3(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftmaster/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Shift Master By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getSchedulePatternById(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/findbyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Shift Patterb By Id', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleGroup(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/schedulegroup/listbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Group', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getShiftPatternByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Pattern By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByUser(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/findbyuserid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By User', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByUserV3(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/scheduleshift/findbyuserid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By User', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByGroup(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/findbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By Group', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByGroupV3(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/scheduleshift/findbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By Group', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByCompany(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getScheduleShiftByCompanyV3(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/scheduleshift/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getSchedulePatternByGroup(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/findbygroupid`
        const result = await axios.get(url, {
          ...costumHeader('Get Schedule Shift By Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveScheduleUpload(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/schedule/upload`
        const result = await axios.post(url, body, costumHeader('Save Employee Schedule Shift', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveScheduleUploadV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/schedule/upload`
        const result = await axios.post(url, body, costumHeader('Save Employee Schedule Shift', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveScheduleShift(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftmaster/add`
        const result = await axios.post(url, body, costumHeader('Save Employee Schedule Shift', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: router.app.$t('codeAlreadyExist')})

        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveScheduleShiftV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/shiftmaster/add`
        const result = await axios.post(url, body, costumHeader('Save Employee Schedule Shift', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: router.app.$t('codeAlreadyExist')})

        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveSchedulePattern(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/insert`
        const result = await axios.post(url, body, costumHeader('Save Schedule Pattern', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveScheduleWork(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/add`
        const result = await axios.post(url, body, costumHeader('Save Schedule Work', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveScheduleUser(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleuser/update`
        const result = await axios.post(url, body, costumHeader('Save Employee Schedule', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editScheduleShift(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftmaster/edit`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Shift', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editScheduleShiftV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/shiftmaster/edit`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Shift', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editScheduleWork(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/edit`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Work', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  populateSchedule(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/scheduleshift/shiftingclean`
        const result = await axios.get(url, {
          ...costumHeader('Populate Schedule Shfting', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  editScheduleWorkV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/edit`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Work', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  insertScheduleWorkV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/add`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Work', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editSchedulePattern(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/edit`
        const result = await axios.post(url, body, costumHeader('Edit Schedule Pattern', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteScheduleShift(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftmaster/delete`
        const result = await axios.post(url, body, costumHeader('Delete Schedule Shift', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteScheduleShiftV3(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/shiftmaster/delete`
        const result = await axios.post(url, body, costumHeader('Delete Schedule Shift', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteSchedulePattern(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/shiftpattern/delete`
        const result = await axios.post(url, body, costumHeader('Delete Schedule Shift Pattern', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteScheduleWork(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/scheduleshift/delete`
        const result = await axios.post(url, body, costumHeader('Delete Schedule Shift Work', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }